import { StyleSheet, Dimensions } from 'react-native'
import { isAndroid } from '../../../utils/platformUtils'
import theme from '../../../../theme'
import { colorText, HighLightColors } from '../../../../themeConstants'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    parent: {
        flex: 1,
        justifyContent: 'center',
    },
    container: {
        flex: 1,
        height: Dimensions.get('window').height,
        backgroundColor: theme.colors.colorPrimary,
    },
    questionContainer: {
        paddingHorizontal: 15,
        paddingBottom: 10,
    },
    optionsContainer: {
        marginVertical: 20,
    },
    optionsSubContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    buttonContainer: {
        flexDirection: 'column',
        bottom: 15,
        marginVertical: 15,
        justifyContent: 'center',
        alignItems: 'center',
    },
    buttonContainerExtra: {
        marginHorizontal: 15,
        alignSelf: 'center',
    },
    marginFive: {
        margin: 5,
    },
    paddingTop: {
        paddingTop: 15,
    },
    optionText: {
        fontSize: 26,
        fontWeight: 'bold',
        color: colorText,
        marginHorizontal: 0,
        textAlign: 'left',
    },
    backIcon: {
        paddingLeft: 15,
        paddingTop: isAndroid() ? 12 : 45,
        marginBottom: 8,
    },
    containerEditIcon: {
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'center',
    },
    containerStarIcon: {
        flexDirection: 'row',
        alignContent: 'center',
        justifyContent: 'center',
        paddingBottom: 8,
    },
    editIcon: {
        justifyContent: 'Top',
        marginTop: 0,
        paddingHorizontal: 8,
    },
    titleEvaluationText: {
        fontSize: 14,
        color: colorText,
        fontWeight: 'normal',
        marginBottom: 4,
        paddingLeft: 15,
    },
    optionTextDetails: {
        fontSize: 15,
        color: colorText,
        fontWeight: 'bold',
        marginBottom: 15,
        paddingLeft: 15,
    },
    completeBlanksContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
        paddingTop: 25,
    },
    optionContainer: {
        paddingVertical: 10,
        marginHorizontal: 2,
        marginBottom: 12,
        borderColor: 'white',
        backgroundColor: 'transparent',
        borderRadius: 12,
        borderWidth: 1.0,
    },
    options: {
        fontSize: 18,
        textAlign: 'center',
        fontWeight: 'medium',
        color: colorText,
        paddingHorizontal: 30,
    },
    selectedOption: {
        backgroundColor: 'white',
    },
    selectedOptionText: {
        color: theme.colors.textPrimary,
    },
    correctOptionText: {
        color: 'lightGray',
    },
    textNext: {
        fontSize: 16,
        textAlign: 'center',
        fontWeight: 'bold',
        color: 'white',
    },
    mainButton: {
        width: 'auto',
        marginTop: 10,
        backgroundColor: theme.colors.colorPrimary,
        paddingVertical: 7,
        paddingHorizontal: 30,
        borderRadius: 15,
        fontSize: 14,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
        overflow: 'hidden',
    },
    mainButtonText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    borderButton: {
        backgroundColor: 'white',
        paddingVertical: 10,
        paddingHorizontal: 50,
        borderRadius: 100,
    },
    borderButtonText: {
        color: 'white',
        fontWeight: 'bold',
        fontSize: 18,
        textAlign: 'center',
    },
    closeBlock: {
        marginTop: 10,
        borderColor: 'white',
        borderWidth: 1.2,
        paddingVertical: 10,
        paddingHorizontal: 40,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
    },
    closeText: {
        fontSize: 16,
        color: 'white',
        fontWeight: 'bold',
    },
    feedbackContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        paddingBottom: 65,
    },
    feedbackAssetContainer: {
        paddingBottom: 4,
    },
    feedbackInfoContainer: {},
    feedbackAsset: {
        justifyContent: 'center',
        width: width - 20,
        height: width - 20,
    },
    feedbackTitle: {
        fontSize: 22,
        fontWeight: 'bold',
        textAlign: 'center',
        color: 'white',
        marginBottom: 10,
        marginTop: -40,
    },
    feedbackDescription: {
        fontSize: 18,
        textAlign: 'center',
        color: 'white',
        paddingHorizontal: 20,
        marginBottom: 20,
    },
    feedbackQuestion: {
        fontSize: 17,
        fontWeight: 'bold',
        textAlign: 'center',
        color: 'white',
        marginTop: 30,
        marginBottom: 10,
        marginHorizontal: 10,
    },
    surveyBlock: {
        paddingBottom: 0,
        marginHorizontal: 20,
    },
    feedbackScore: {
        fontSize: 20,
        fontWeight: 'bold',
        textAlign: 'center',
        color: theme.colors.alert,
        marginBottom: 10,
        marginHorizontal: 20,
    },
    textRestart: {
        fontSize: 16,
        textAlign: 'center',
        fontWeight: 'bold',
        color: 'white',
    },
    input: {
        borderColor: 'rgb(1, 111, 240)',
        backgroundColor: 'rgba(1, 111, 240, 0.1)',
        borderWidth: 1,
        borderRadius: 20,
        paddingLeft: 8,
        flexGrow: 1,
        alignSelf: 'stretch',

        //flex: 1,
    },
    inputContainer: {
        margin: 0,
    },
    inputField: {
        width: '100%',
        height: '50%',
        padding: 10,
        fontSize: 14,
        borderWidth: 1.5,
        borderColor: 'white',
        borderRadius: 5,
        justifyContent: 'center',
        backgroundColor: 'white',
    },
    optionImage: {
        width: 300,
        aspectRatio: 1 / 1,
        borderRadius: 10,
        margin: 10,
        overflow: 'hidden',
    },
    selectedOptionImage: {
        borderColor: theme.colors.colorSecondary, // Estilo adicional para la imagen seleccionada
        borderWidth: 4,
    },
    imageContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap', // Permite que las imágenes se envuelvan a la siguiente fila si no caben en la actual
        justifyContent: 'center', // Centra las imágenes horizontalmente
        alignItems: 'center', // Centra las imágenes verticalmente
    },
    optionChip: {
        borderRadius: 20,
        borderColor: 'rgb(1, 111, 240)',
        minWidth: 100,
        borderWidth: 2,
        padding: 4,
    },
    chip: {
        borderRadius: 15,
        borderColor: 'white',
        minWidth: 100,
        height: 30,
        textAlign: 'center',
        marginRight: 10,
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        borderWidth: 1,
        borderStyle: 'dashed', // Agrega líneas punteadas al borde,
    },
    complete: {
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
    },
    chipText: {
        fontSize: 26,
        fontWeight: 'bold',
        color: theme.colors.alert,
        marginRight: 10,
    },
    container_image: {
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        marginTop: 10,
    },
    IntermodalImage: {
        width: 150,
        height: 150,
        borderRadius: 0,
    },
    modalBox: {
        backgroundColor: 'white',
        width: Dimensions.get('window').width * 0.8,
        borderRadius: 10,
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        color: theme.colors.modalBackground,
        padding: 35,
    },
    modalText: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 10,
        fontWeight: 'bold',
    },
    modalText2: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
    },
    modalText3: {
        fontSize: 12,
        color: 'black',
        textAlign: 'center',
        marginTop: 10,
        marginBottom: 10,
    },
    highLightOptionCorrectContainer: {
        backgroundColor: HighLightColors.correctBackgorundColor,
        borderColor: HighLightColors.correctBorderColor,
    },
    highLightOptionCorrectText: {
        color: HighLightColors.correctTextColor,
    },
    highLightOptionIncorrectContainer: {
        backgroundColor: HighLightColors.incorrectBackgorundColor,
        borderColor: HighLightColors.incorrectBorderColor,
    },
    highLightOptionIncorrectText: {
        color: HighLightColors.incorrectTextColor,
    },
    correctNotSelectedContainer: {
        backgroundColor: 'white',
        borderColor: HighLightColors.correctBorderColor,
        borderWidth: 3,
    },
    correctNotSelectedText: {
        color: 'black',
    },
})

export default styles
